import React, { createContext, useState, useCallback, useMemo, useContext } from 'react';
import { utilityMeterService } from '../services/UtilityMeterService';

export const UtilityMeterContext = createContext();

export const UtilityMeterProvider = props => {
    const [utilityMeters, setUtilityMeters] = useState([]);
    const [count, setCount] = useState(0);

    const getUtilityMeters = useCallback((utilityAccountId, type = null) => {
        setUtilityMeters([]);
        return utilityMeterService
            .getUtilityMeters(utilityAccountId, type)
            .then(res => {
                setUtilityMeters(res?.data ?? []);
                setCount(res?.count ?? 0);
            });
    }, []);

    const createUtilityMeter = useCallback((utilityAccountId, meter) => {
        return utilityMeterService.createUtilityMeter(utilityAccountId, meter);
    }, []);

    const updateUtilityMeter = useCallback((utilityMeterId, meter) => {
        return utilityMeterService.updateUtilityMeter(utilityMeterId, meter);
    }, []);

    const deleteUtilityMeter = useCallback((utilityMeterId) => {
        return utilityMeterService.deleteUtilityMeter(utilityMeterId);
    }, []);

    const uploadUtilityMeterData = useCallback((meterId, dataArray) => {
        return utilityMeterService.uploadMeterData(meterId, dataArray);
    }, []);

    const values = useMemo(
        () => ({
            utilityMeters,
            count,
            getUtilityMeters,
            createUtilityMeter,
            updateUtilityMeter,
            deleteUtilityMeter,
            uploadUtilityMeterData,
        }),
        [utilityMeters, count, getUtilityMeters, createUtilityMeter, updateUtilityMeter, deleteUtilityMeter, uploadUtilityMeterData]
    );

    return <UtilityMeterContext.Provider value={values}>{props.children}</UtilityMeterContext.Provider>;
};

export const useUtilityMeters = () => {
    const context = useContext(UtilityMeterContext);
    if (context === undefined) {
        throw new Error('useUtilityMeters must be used within a UtilityMeterProvider component.');
    }
    return context;
};
